import {
  CLEAR_RISK,
  ADD_RISK_CHECK_START,
  ADD_RISK_CHECK_SUCCESS,
  ADD_RISK_CHECK,
  DISPATCH_ADD_RISK_CHECK,
  REMOVE_RISK_CHECK_START,
  REMOVE_RISK_CHECK_SUCCESS,
  REMOVE_RISK_CHECK,
  DISPATCH_REMOVE_RISK_CHECK,
  UPDATE_VALUE,
  UPDATE_VALIDATION_VALUE,
} from './constants'

const addRiskCheckStart = () => ({ type: ADD_RISK_CHECK_START })
const addRiskCheckSuccess = () => ({ type: ADD_RISK_CHECK_SUCCESS })
const addRiskCheck = (id) => ({ type: ADD_RISK_CHECK, id })
const dispatchAddRiskCheck = (id) => ({ type: DISPATCH_ADD_RISK_CHECK, id })
const removeRiskCheckStart = () => ({ type: REMOVE_RISK_CHECK_START })
const removeRiskCheckSuccess = () => ({ type: REMOVE_RISK_CHECK_SUCCESS })
const removeRiskCheck = (id) => ({ type: REMOVE_RISK_CHECK, id })
const dispatchRemoveRiskCheck = (id) => ({ type: DISPATCH_REMOVE_RISK_CHECK, id })
const clearRisk = () => ({ type: CLEAR_RISK })
const updateValue = (value) => ({ type: UPDATE_VALUE, value })
const updateValidationValue = () => ({ type: UPDATE_VALIDATION_VALUE })

export {
  updateValidationValue,
  clearRisk,
  updateValue,
  addRiskCheckStart,
  addRiskCheckSuccess,
  addRiskCheck,
  dispatchAddRiskCheck,
  removeRiskCheckStart,
  removeRiskCheckSuccess,
  removeRiskCheck,
  dispatchRemoveRiskCheck,
}
